import React, { Fragment } from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies
import {
  MDCNotchedOutlineFoundation,
} from '@material/notched-outline/dist/mdc.notchedOutline';

class NothedOutline extends React.PureComponent {
  constructor(props) {
    super(props);

    this.foundation = new MDCNotchedOutlineFoundation({
      getWidth: () => this.outline.offsetWidth,
      getHeight: () => this.outline.offsetHeight,
      addClass: className => this.outline.classList.add(className),
      removeClass: className => this.outline.classList.remove(className),
      setOutlinePathAttr: value => this.path.setAttribute('d', value),
      getIdleOutlineStyleValue: propertyName => window
        .getComputedStyle(this.idle)
        .getPropertyValue(propertyName),
    });
  }

  componentDidMount() {
    this.foundation.init();
  }

  componentWillUnmount() {
    this.foundation.destroy();
  }

  render() {
    return (
      <Fragment>
        <div className="mdc-notched-outline" ref={(outline) => { this.outline = outline; }} >
          <svg>
            <path className="mdc-notched-outline__path" ref={(path) => { this.path = path; }} />
          </svg>
        </div>
        <div className="mdc-notched-outline__idle" ref={(idle) => { this.idle = idle; }} />
      </Fragment>
    );
  }
}

export default NothedOutline;
